export interface AdministratorPlayersProfileDiagnosticsListFormRemove {
  id: string;
  user_id: string;
  organization_id: string;
  diagnostic_category_id: string;
  diagnostic_category: {
    id: string;
    content: {
      name: string;
      fields: any;
    };
  };
  user: {
    id: string;
    content: {
      name: string;
      surname: string;
    };
  };
  content: {
    date: string;
    fields: any;
  };
}

export class AdministratorPlayersProfileDiagnosticsListFormRemove implements AdministratorPlayersProfileDiagnosticsListFormRemove {
  id: string;
  user_id: string;
  organization_id: string;
  diagnostic_category_id: string;
  diagnostic_category: {
    id: string;
    content: {
      name: string;
      fields: any;
    };
  };
  user: {
    id: string;
    content: {
      name: string;
      surname: string;
    };
  };
  content: {
    date: string;
    fields: any;
  };

  constructor(organization_id?: string) {
    this.id = "";
    this.user_id = "";
    this.organization_id = organization_id ?? null;
    this.diagnostic_category_id = "";
    this.diagnostic_category = {
      id: "",
      content: {
        name: "",
        fields: [],
      },
    };
    this.user = {
      id: "",
      content: {
        name: "",
        surname: "",
      },
    };
    this.content = {
      date: "",
      fields: [],
    };
  }
}